import OneSignal from 'onesignal-cordova-plugin';

export const oneSignalInit = () => {
  OneSignal.setLogLevel(6, 0);
  OneSignal.setLocationShared(false); //https://github.com/OneSignal/OneSignal-iOS-SDK/issues/368#issuecomment-418200055
  OneSignal.setAppId(import.meta.env.VITE_ONESIGNAL_APP_ID);
};
